/** Presentation contract emitted by previous_information.source_note and suggestion generation. */
export const splitEarlierPassage = (
  text: string,
): { explanation: string; earlierPassages: string[] } => {
  const [explanation, ...earlierPassages] = text.split(" Earlier passage: ");
  // In merged suggestions, each chunk also contains the next explanation.
  // Preserve it verbatim: the backend does not delimit the end of a quote.
  return { explanation, earlierPassages };
};

export const parsePreviouslyMentionedSource = (
  text: string,
): { prefix: string; entryLabel: string; suffix: string } | null => {
  const match = text.match(
    /^(Previously mentioned in the )(\d{4}-\d{2}-\d{2} entry)\./,
  );
  if (!match) return null;
  const [, prefix, entryLabel] = match;
  return {
    prefix,
    entryLabel,
    suffix: text.slice(prefix.length + entryLabel.length),
  };
};
